import { render, staticRenderFns } from "./m1_footer.vue?vue&type=template&id=5f3b476d&"
import script from "./footer.js?vue&type=script&lang=js&"
export * from "./footer.js?vue&type=script&lang=js&"
import style0 from "./m1_footer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports